module.exports = __webpack_public_path__ + "img/barcode.12090977.jpg";